import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Users, Heart, Shield, Laptop, Globe } from 'lucide-react';
import { features } from '../../data/schoolInfo';

const iconMap = {
  Building2,
  Users,
  Heart,
  Shield,
  Laptop,
  Globe,
};

const WhyChooseUs = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-1 bg-primary-100 text-primary-600 rounded-full text-sm font-medium mb-4">
            Why Stirret Schools
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            What Sets Us Apart
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine academic excellence with character development to nurture
            well-rounded individuals ready for global success.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon] || Building2;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group p-6 bg-gray-50 rounded-2xl hover:bg-primary-600 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-primary-100 group-hover:bg-white/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                  <Icon className="text-primary-600 group-hover:text-white transition-colors" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-white mb-3 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 group-hover:text-white/80 transition-colors">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
